import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, throwError } from 'rxjs';
import { Failure } from '../errors/failure.model';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const messageService = inject(MessageService);
  const oidc = inject(OidcSecurityService);

  // Don't intercept KeyCloak requests
  if (req.url.includes('/realms/') || req.url.includes('/openid-connect/')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const failure = mapToFailure(error);
      showError(messageService, failure);

      if (error.status === 401) {
        oidc.authorize();
      }

      return throwError(() => failure);
    }),
  );
};

function mapToFailure(error: HttpErrorResponse): Failure {
  switch (error.status) {
    case 0:
      return {
        kind: 'network',
        message: 'Impossible de contacter le serveur. Verifiez votre connexion reseau.',
        statusCode: 0,
      };
    case 401:
      return {
        kind: 'server',
        message: 'Session expiree. Reconnexion en cours...',
        statusCode: 401,
      };
    case 403:
      return {
        kind: 'server',
        message: "Acces refuse. Vous n'avez pas les droits necessaires.",
        statusCode: 403,
      };
    case 408:
      return {
        kind: 'network',
        message: "Delai d'attente depasse. Veuillez reessayer.",
        statusCode: 408,
      };
    case 500:
      return {
        kind: 'server',
        message: 'Erreur interne du serveur. Veuillez reessayer plus tard.',
        statusCode: 500,
      };
    default:
      if (error.status >= 400 && error.status < 500) {
        console.warn(`[API] Client error ${error.status}:`, error.message);
      } else {
        console.error(`[API] Server error ${error.status}:`, error.message);
      }
      return {
        kind: 'unknown',
        message: 'Une erreur inattendue est survenue.',
        statusCode: error.status,
      };
  }
}

function showError(messageService: MessageService, failure: Failure): void {
  const life = failure.statusCode === 401 ? 2000 : 5000;
  messageService.add({
    severity: 'error',
    summary: 'Erreur',
    detail: failure.message,
    life,
  });
}
